export default __webpack_public_path__ + "static/media/connoisseur.252ac52e.svg";